import { SectionHead, Reveal, PageHero, usePageMeta } from "@/components/primitives";
import { Validation, VisionMission, FinalCTA } from "@/components/blocks2";
import { TechLine } from "@/components/blocks1";
import Founders, { FounderTimeline } from "@/components/Founders";

export default function About() {
  usePageMeta(
    "Avyagrah Tech Innovations | Building Financial Infrastructure for Bharat",
    "Avyagrah Tech Innovations Private Limited — Engineering Tomorrow with Intelligence. TimePe is our sovereign AI-powered financial infrastructure platform for Bharat."
  );
  return (
    <>
      <PageHero
        eyebrow="About Us — Avyagrah Tech Innovations • Powering TimePe"
        lines={["Engineering Tomorrow", "with Intelligence."]}
        lead="Avyagrah Tech Innovations Private Limited is a Bharat-first DeepTech company. TimePe — our flagship platform — is sovereign, AI-powered financial infrastructure: Secure for Bharat. Built in Bharat, for Bharat."
      />

      <section className="border-b border-line py-24 sm:py-32" data-testid="about-story">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
          <div className="grid gap-14 lg:grid-cols-2">
            <div>
              <SectionHead eyebrow="The Company" title="Not Another Payment App." />
              <Reveal className="mt-8 space-y-5 text-base leading-relaxed text-mute">
                <p>
                  TimePe is a compliance-first, sovereign AI-powered financial infrastructure platform
                  designed to make digital financial services more secure, privacy-first, transparent
                  and accessible — connecting payments, banking, insurance and last-mile financial
                  access through intelligent technology.
                </p>
                <p>
                  TimePe operates at the intersection of FinTech, RegTech, AI, Cybersecurity and Data
                  Intelligence, embedding risk intelligence, privacy-by-design, behavioral analytics,
                  device intelligence and automated compliance into financial workflows.
                </p>
              </Reveal>
              <Reveal delay={0.1} className="mt-8">
                <TechLine />
              </Reveal>
            </div>
            <div className="flex flex-col gap-5">
              {[
                { q: "Avyagrah Tech Innovations", a: "Engineering Tomorrow with Intelligence.", tone: "text-electric" },
                { q: "TimePe", a: "Secure for Bharat. Built in Bharat, for Bharat.", tone: "text-teal" },
              ].map((b) => (
                <Reveal key={b.q}>
                  <div className="rounded-2xl border border-line bg-panel/70 p-8">
                    <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-mute">{b.q}</p>
                    <p className={`mt-3 font-display text-2xl font-bold tracking-tight ${b.tone}`}>{b.a}</p>
                  </div>
                </Reveal>
              ))}
              <Reveal delay={0.1}>
                <div className="rounded-2xl border border-line bg-panel/70 p-8">
                  <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-mute">The Journey</p>
                  <FounderTimeline />
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <VisionMission />
      <Founders chapter="The Founders" />
      <Validation />
      <FinalCTA />
    </>
  );
}
